import { Routes } from 'config/routes'
import { element } from 'prop-types'
import React, { createContext, useContext, useEffect, useState } from 'react'
import { getUserRequest } from 'shared/application/services/user'
import {
  destroyCredentials,
  getAffiliatesAuthSession,
  getUserInfo,
  removeStorageCampaigns,
  setUserCompanyAndBranch,
  setUserSettings,
} from 'shared/infrastructure/storage'

const authContext = createContext()

const AuthProvider = ({ children }) => {
  const auth = useAuthProvider()
  return <authContext.Provider value={auth}>{children}</authContext.Provider>
}

function useAuth() {
  return useContext(authContext)
}

function useAuthProvider() {
  const [user, setUser] = useState({ role: null })

  const logout = () => {
    destroyCredentials()
    removeStorageCampaigns()
    window.location.assign(Routes.Login)
  }

  const isAuthenticated = () => {
    return getAffiliatesAuthSession() != null
  }

  const mountUser = async () => {
    const userInfo = getUserInfo()?.login?.user
    try {
      const { type, company, branch, permissions} = await getUserRequest()

      setUserCompanyAndBranch({
        company: { ...company },
        branch: { ...branch },
      })

      setUserSettings({setting: {permissions}})
      setUser({ role: type, company, ...userInfo })
    } catch (error) {
      setUser({ role: null, ...userInfo })
    }
  }

  useEffect(() => {
    mountUser()
  }, [])

  return {
    isAuthenticated,
    logout,
    user,
  }
}

AuthProvider.propTypes = {
  children: element,
}

export { useAuth, AuthProvider, useAuthProvider }
